import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TemplateScreenssDocument,
  type TemplateScreenssQuery,
} from '@/graphql/generated/graphql';

export type TemplateScreenRecord = NonNullable<
  NonNullable<TemplateScreenssQuery['getTemplateScreenss']>['items']
>[number];
export type GetTemplateScreensResponse = TemplateScreenssQuery;

export const useGetTemplateScreens = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { templateId: 'TemplateId' });
  return useQuery({
    queryKey: ['template-screens', variables],
    queryFn: () => graphqlClient.request(TemplateScreenssDocument, variables),
  });
};

export const requestTemplateScreens = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { templateId: 'TemplateId' });
  return graphqlClient.request(TemplateScreenssDocument, variables);
};

export const GET_TEMPLATE_SCREENS_QUERY = TemplateScreenssDocument;
